
(async function () {

  // Handle Product Query Form
  const enquiryForm = document.getElementById('enquiry-form');
  const customSwal = Swal.mixin({
    customClass: {
      confirmButton: 'button button--primary',
      cancelButton: 'button button--primary'
    },
    buttonsStyling: false
  });

  if (enquiryForm == undefined) {
    console.log('Enquiry form does not exist')
  } else {
    const myHeaders = new Headers();
    myHeaders.append('x-api-key', '6XHzlHGCFQ96QW6f4uxN44HCpGvXJf2yL7WN5XSg');
    myHeaders.append('Content-Type', 'application/json');
    let brandsList;

    /**
     * Get all Appliance types
     * @returns 
     */
    async function getApplianceTypes() {
      return new Promise(async (resolve, reject) => {
        const applianceTypes = await fetch('https://apis.needapart.co.nz/appliances', {
          method: 'GET',
          credentials: 'same-origin',
          redirect: "follow",
          headers: myHeaders,
        })
          .then(res => res.json())
          .catch(e => reject(e));

        resolve(applianceTypes?.appliances);
      })

    }

    /**
     * Get all Brands
     * @returns 
     */
    async function getBrandsList() {
      return new Promise(async (resolve, reject) => {
        const brands = await fetch('https://apis.needapart.co.nz/brands', {
          method: 'GET',
          credentials: 'same-origin',
          redirect: "follow",
          headers: myHeaders,
        }).then(res => res.json())
          .catch(e => reject(e));

        resolve(brands?.brands);
      })
    }


  /**
   * Show/Hide form field based on ID & Status
   * @param {*} id 
   * @param {*} visibility 
   */
  function toggleFormField(id, visibility) {
    const field = document.getElementById(`${id}`);

    switch(visibility) {    
      case 'show':
        field.setAttribute('required', true);
        field.closest('.field').style.display = 'block';
        break;
        case 'hide':
          field.removeAttribute('required');
          field.closest('.field').style.display = 'none';
        break;
        default: 
        console.log('Set a valid visibilty status');
        break;
    }
  }

    /**
     * Get Models based on Appliance Type & Brand
     * @param {*} appliance 
     * @param {*} brand 
     * @returns 
     */
    async function getModelsList(appliance, brand) {
      const models = await fetch(`https://apis.needapart.co.nz/models?brand=${brand}`, {
        method: 'GET',
        credentials: 'same-origin',
        redirect: "follow",
        headers: myHeaders,
      }).then(res => res.json())
        .catch(e => console.log(e))

      const filteredModels = models.models.filter(model => model.appliance == appliance);
      
      return filteredModels;
    }

    /**
     * Populate Models based oon Appliance Type & Brand
     * @param {*} applianceValue 
     * @param {*} brandValue 
     */
    async function populateModels(applianceValue, brandValue) {
      enquiryForm.classList.add('loadingOverlay');
      const selectedBrand = brandsList.filter(brand => brand.brand === brandValue);

      // User may have entered the brand themselves
      if(selectedBrand.length > 0) {
        if (selectedBrand[0].requiresSerialNumber === true) {
          toggleFormField('serialNo', 'show');
        } else {
          toggleFormField('serialNo', 'hide');
        }
      }

      const models = await getModelsList(applianceValue, brandValue);
      
      if (models.length > 0) {
        const modelsEl = document.createElement('div');
        models.forEach(el => {
          modelsEl.insertAdjacentHTML('beforeend', `<option>${el.model}</option>`);
        });

        document.getElementById('modelList').innerHTML = modelsEl.innerHTML;

      } else {
        document.getElementById('modelList').innerHTML = '';
        document.getElementById('modelNo').value = '';
      }
      enquiryForm.classList.remove('loadingOverlay');
    }


    function init() {
      const promiseArr = []; // Empty array to push all async fns
      const applianceTypeInput = document.getElementById('applianceTypes');
      const brandsInput = document.getElementById('brands');

      // Add Loader on load
      enquiryForm.classList.add('loadingOverlay');

      promiseArr.push(getApplianceTypes());
      promiseArr.push(getBrandsList());

      Promise.all(promiseArr)
        .then(res => {
          // Populate Appliance Types 
          const applianceTypesEl = document.createElement('div');
          res[0].forEach(el => {
            applianceTypesEl.insertAdjacentHTML('beforeend', `<option>${el}</option>`);
          });

          document.getElementById('applianceTypesList').innerHTML = applianceTypesEl.innerHTML;

          // Populate Brands
          const brandsEl = document.createElement('div');
          brandsList = res[1];
          res[1].forEach(el => {
            brandsEl.insertAdjacentHTML('beforeend', `<option value="${el.brand}" data-requiredSerialNo="${el.requiresSerialNumber}">${el.brand}</option>`);
          });

          document.getElementById('brandList').innerHTML = brandsEl.innerHTML;

          // Remove Loader
          enquiryForm.classList.remove('loadingOverlay');
        })
        .then(() => {
          // Check if values for both appliance type and brand are pre loaded
          if (applianceTypeInput.value !== "" && brandsInput.value !== "") {
            populateModels(applianceTypeInput.value, brandsInput.value);
          }
        })
        .catch(e => console.log(e));
    }

    // Initialize
    init();

    // Listen to change in any of the 3 input values
    enquiryForm.addEventListener('change', async e => {
      const applianceValue = enquiryForm.querySelector('#applianceTypes').value;
      const brandValue = enquiryForm.querySelector('#brands').value;

      if ((e.target.id == 'applianceTypes' || e.target.id == 'brands') && applianceValue !== '' && brandValue !== '') {
        populateModels(applianceValue, brandValue);
      }

      if(e.target.id == 'photo') {
        if (e.target.files && e.target.files[0]) {
          let reader = new FileReader();
            
          reader.addEventListener("load", function(evt) {
            document.querySelector('#photo_data').value = evt.target.result;
          }); 
            
          reader.readAsDataURL(e.target.files[0]);        
        }
      }
    });

    // Handle form submission
    enquiryForm.addEventListener('submit', async e => {
      e.preventDefault();

      const formData = new FormData(e.target);
      const formProps = Object.fromEntries(formData);

      // Get Data from Inputs
      const payload = {
        customer: {
          "name": formProps.first_name != undefined ? formProps.first_name : null,
          "email": formProps.email_address != undefined ? formProps.email_address : null,
          "phone": formProps.phone_no != undefined ? formProps.phone_no : null,
          "type": formProps.customer_type != undefined ? formProps.customer_type : 'consumer',
        },
        parts: [
          {
            "appliance": formProps.appliance_type != undefined ? formProps.appliance_type : null,
            "brand": formProps.brand_name != undefined ? formProps.brand_name : null,
            "model": formProps.model_no != undefined ? formProps.model_no : null,
            "serial": formProps.serial_no != undefined ? formProps.serial_no : null,
            "image": formProps.photo_data != undefined ? formProps.photo_data : null,
            "part": formProps.product_title != undefined ? formProps.product_title : formProps.part_type,
            "qty": formProps.quantity != undefined ? formProps.quantity : null,
            "product": {
              "title": formProps.product_title != undefined ? formProps.product_title : null,
              "id": formProps.variant_id != undefined ? parseInt(formProps.variant_id) : null,
              "sku": formProps.sku != undefined ? formProps.sku : null,
              "partNumber": formProps.part_number != undefined ? formProps.part_number : null
            }
          }
        ]
      }

      enquiryForm.classList.add('loadingOverlay');

      const res = await fetch('https://apis.needapart.co.nz/enquiries/create', {
        method: 'POST',
        headers: myHeaders,
        body: JSON.stringify(payload)
      }).then(res => res.json());

      enquiryForm.classList.remove('loadingOverlay');

      if (res.enquiryId) {
        customSwal.fire({
          title: 'Success!',
          text: `Thanks! We have received your enquiry, and your reference number is ${res.enquiryId}. We will get back to you shortly`,
          icon: 'success',
        }).then((res) => {
          // If we need to reset form here, we can do that.
          // window.location.reload();
        })
      } else {
        customSwal.fire({
          title: 'Error!',
          html: 'Sorry, we have not received your enquiry due to a system error. Please <a href="/pages/contact">contact us</a>',
          icon: 'error',
        }).then((res) => {
          // If we need to reset form here, we can do that.
          window.location.reload();
        })
      }
    });
  }
})();